import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, ArrowUpRight } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-600 flex items-center justify-center">
                <span className="text-white font-bold text-xl font-serif">R</span>
              </div>
              <div>
                <p className="font-serif font-semibold text-white text-xl">Riya AlcoBev Solutions</p>
                <p className="text-sm text-slate-400 tracking-wider uppercase">Manufacturing Excellence</p>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed max-w-md mb-8">
              Future-ready manufacturing solutions for the AlcoBev industry. 
              With over 37 years of industry expertise, we help organizations achieve 
              operational excellence and sustainable growth.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-slate-700 flex items-center justify-center hover:bg-blue-600 hover:border-blue-600 transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-4">
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Services', path: '/services' },
                { name: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-white transition-colors flex items-center gap-2 group"
                  >
                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+919686777558" 
                  className="text-slate-400 hover:text-white transition-colors flex items-start gap-3"
                >
                  <Phone className="w-5 h-5 mt-0.5 text-blue-500" />
                  <span>+91 9686777558</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:ragunath.v@riyaalcobev.com" 
                  className="text-slate-400 hover:text-white transition-colors flex items-start gap-3"
                >
                  <Mail className="w-5 h-5 mt-0.5 text-blue-500" />
                  <span>ragunath.v@riyaalcobev.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 mt-0.5 text-blue-500 flex-shrink-0" />
                <span>India</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <p>© {currentYear} Riya AlcoBev Solutions. All rights reserved.</p>
            <p>Transforming Manufacturing Excellence</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
